import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NavigationExtras, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class RoutableModalsStateService {
    private readonly initialStateSubject: BehaviorSubject<Record<string, unknown>> = new BehaviorSubject<Record<string, unknown>>(null);

    constructor(private readonly router: Router) {
    }

    navigateWithData({ commands, extras }: { commands: any[], extras?: NavigationExtras }, data?: Record<string, unknown>): void {
        this.initialStateSubject.next(data);
        this.router.navigate(commands, extras);
    }

    getAndClearInitialState(): Record<string, unknown> {
        const initialState = this.initialStateSubject.getValue();
        this.initialStateSubject.next(null);
        return initialState;
    }
}
